import { Avatar, Box, Fab, Stack, Typography } from '@mui/material';
import { ClientData } from './types';
import { callButtonStyles, modalStyles } from './styles';
import { Call } from '@mui/icons-material';

export const PhoneDialerClientInfo = ({
  clientData,
  onCall,
}: {
  clientData: ClientData,
  onCall: () => void;
 }) => (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      gap={1}
      alignItems="center"
      sx={{
        ...modalStyles.mainContainer,
        boxSizing: 'border-box',
      }}
    >
      <Stack
        gap={2}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Avatar sx={{ width: 52, height: 52, margin: '0 auto' }} />
        <Stack>
          <Typography color="primary" variant="h6" align="center">
            {clientData.clientFirstName && clientData.clientLastName ? 
                `${clientData.clientFirstName} ${clientData.clientLastName}` :
                  clientData.clientFirstName || clientData.clientLastName}
          </Typography>
          <Typography color="grey" variant="body2" align={'center'}>
            {clientData?.clientEmail}
          </Typography>
          <Typography color="grey" variant="body2" align={'center'}>
          (+{clientData?.clientPhoneCountryCode}) {clientData?.clientPhoneNumber}
          </Typography>
        </Stack>
      </Stack>
      
      <Box sx={callButtonStyles.container} mt={2}>
        <Fab onClick={onCall} color="success" aria-label="call" size="large" sx={callButtonStyles.fab}>
          <Call />
        </Fab>
      </Box>
    </Box>
  );
